export enum SaveState {
	NONE = 'none',
	PENDING = 'pending',
	SUCCESS = 'success',
	FAILURE = 'failure'
}

export const LoginUserStates = {
	UNCONFIRMED: 'Login details have been created but not confirmed.',
	CONFIRMED: 'Login details have been confirmed.',
	ARCHIVED: 'Login details are no longer active.',
	COMPROMISED: 'Logins are disabled due to a potential security threat.',
	UNKNOWN: 'Login status is not known.',
	RESET_REQUIRED: 'Login details are confirmed, but the user must reset their password before they can sign in.',
	FORCE_CHANGE_PASSWORD: 'The user is confirmed and the user can sign in using a temporary password. On first sign-in, the user must change their password to a new value before doing anything else.'
} as const;

export const APP_LOCATION_CHANGE = 'APP_LOCATION_CHANGE';
// tslint:disable-next-line: interface-name
export interface LocationChangeAction { type: typeof APP_LOCATION_CHANGE; }
